import { render, staticRenderFns } from "./Work_better.vue?vue&type=template&id=a7de35d8&"
import script from "./Work_better.vue?vue&type=script&lang=js&"
export * from "./Work_better.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports